var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66146 13.3337C2.29479 13.3337 1.98101 13.2032 1.72013 12.9423C1.45924 12.6814 1.32857 12.3674 1.32812 12.0003V4.00033C1.32812 3.63366 1.45879 3.31988 1.72013 3.05899C1.98146 2.7981 2.29524 2.66744 2.66146 2.66699H9.99479C10.2059 2.66699 10.4059 2.71433 10.5948 2.80899C10.7837 2.90366 10.9392 3.0341 11.0615 3.20033L14.6615 8.00032L11.0615 12.8003C10.9392 12.967 10.7837 13.0977 10.5948 13.1923C10.4059 13.287 10.2059 13.3341 9.99479 13.3337H2.66146ZM2.66146 12.0003H9.99479L12.9948 8.00032L9.99479 4.00033H2.66146V12.0003Z",
    fill: "#636874"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.e842d6741011416f372b236ceb4e89bd.svg";
export { ForwardRef as ReactComponent };